import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const ZONES_TABS = [
  'info',
  'config',
  'webshop',
  'images',
  'texts',
  'text_blocks',
  'hotel',
  'algorithm',
  'geolocation',
  'directions',
] as const;

export type ZonesTabs = (typeof ZONES_TABS)[number];

export const ZonesPath: MainPath = '/zones/:id?/:section?';
export const ZonesRoute: MainNavRoute = {
  path: '/zones',
  label: 'routes.zones',
  icon: 'zone',
  type: 1,
  permissions: [PERMISSIONS.ZONES__LIST],
  children: [
    {
      path: ':id',
      disowned: true,
      type: 1,
      permissions: [PERMISSIONS.ZONES__DETAILS],
      children: makeChildren<ZonesTabs>({
        info: { path: 'info' },
        config: { path: 'config' },
        webshop: { path: 'webshop' },
        hotel: { path: 'hotel' },
        algorithm: { path: 'algorithm' },
        geolocation: { path: 'geolocation' },
        texts: { path: 'texts' },
        images: { path: 'images' },
        text_blocks: { path: 'text_blocks' },
        directions: { path: 'directions' },
      }),
    },
  ],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24141/cc22afcb70cac5a',
};
